module.exports = __webpack_public_path__ + "img/windowsview.bb5828df.png";